import { render, staticRenderFns } from "./EditAutomatedReport.vue?vue&type=template&id=47dc514b"
import script from "./EditAutomatedReport.vue?vue&type=script&lang=ts"
export * from "./EditAutomatedReport.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports